/**
 * Employee Address Tab Component
 * 
 * This component is extracted from EmployeeForm.jsx for modularity.
 * It maintains the exact same structure and data-testid attributes.
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';

const AddressTab = ({ formData, handleChange }) => {
  return (
    <Card className="border-border/60">
      <CardHeader>
        <CardTitle className="font-heading">Adresse</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2 md:col-span-1">
            <Label htmlFor="street">Straße</Label>
            <Input
              id="street"
              value={formData.street || ''}
              onChange={(e) => handleChange('street', e.target.value)}
              data-testid="employee-street"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="house_number">Hausnummer</Label>
            <Input
              id="house_number"
              value={formData.house_number || ''}
              onChange={(e) => handleChange('house_number', e.target.value)}
              data-testid="employee-house-number"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="postal_code">PLZ</Label>
            <Input
              id="postal_code"
              value={formData.postal_code || ''}
              onChange={(e) => handleChange('postal_code', e.target.value)}
              data-testid="employee-postal-code"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="city">Stadt</Label>
            <Input
              id="city"
              value={formData.city || ''}
              onChange={(e) => handleChange('city', e.target.value)}
              data-testid="employee-city"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="country">Land</Label>
            <Input
              id="country"
              value={formData.country || ''}
              onChange={(e) => handleChange('country', e.target.value)}
              data-testid="employee-country"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AddressTab;
